import { useEffect } from 'react';
import Footer from './layout/Footer';
import Header from './layout/Header';
import Router from './routes/Router';
import HeaderProm from './components/HeaderProm';
import {
    useDispatch
    , useSelector 

} from "react-redux";
import { initiateTempToken, isTokenValid } from "./api/utils";
import { useLocation } from 'react-router-dom';
import { validateUser } from './app/auth/Auth';
import CartModal from './components/cart/CartModal';

export default function App() {

    const location = useLocation();
    const dispatch = useDispatch();
    // const load = useSelector((state) => state.auth.isLoading);
    const { open } = useSelector((state) => state.cart);

    useEffect(() => {
        const isAuth = isTokenValid();
        if (isAuth.isValide) {
            dispatch(validateUser({
                token: isAuth.token,
                user: isAuth.user,
                exp: isAuth.expTime
            }))
        }
        else {
            initiateTempToken();
        }
        // eslint-disable-next-line
    }, []);

    const dark = [
        "female-intimate-wellness-one",
        "female-intimate-wellness-two",
        "the-rinu-ritual",
        "elemental-alchemy",
        "still-stone-release",
        "inner-sculpt",
        "the-deep-rewire",
        "stretch-and-spirit",
        "essence-of-two",
        "womb-and-whisper",
        "japanese-restorative-head-ritual"
    ];
  
    return (
        <>
            <HeaderProm show={false} />
            <Header />
            {
                open &&
                <CartModal />
            }
            <Router />
            {
                dark.includes(location.pathname.replace('/', '')) ?
                <Footer dark={true} />
                :
                <Footer dark={false} />
            }
        </>
    );
};